<app-address-details-form [initialData]="initialData" testIdPrefix="wizard-address"></app-address-details-form>
